import React, { useEffect,useState } from 'react'
import Orders from 'components/Panel/Subreseller/Orders'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { orders } from 'redux/subreseller/orders/ordersSlice';
import Pagination from 'components/Pagination';


const OrdersContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data } = useSelector(state => state.subresellerOrders.orders);
  const { total, pages, page, per_page } = useSelector(state => state.subresellerOrders.orders);
  const { balance_try } = useSelector(state => state.subresellerProfile.profile);
  const [newP,setNewP] = useState()
  useEffect(() => {
    const fetchOrders = () => {
      dispatch(orders({ page: newP || page, per_page: 30 }))
    };
    fetchOrders();
    const intervalId = setInterval(fetchOrders, 10000);
    return () => {
      clearInterval(intervalId);
    };
  }, [newP]);

  const handlePageChange = (newPage) => {
    setNewP(newPage)
    dispatch(orders({ page: newPage, per_page: 30 }))
  };

  return (
    <div className='bg-black min-h-screen'>
      <div className='p-4 flex flex-col md:flex-row md:justify-between md:items-center gap-4'>
        <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4">
          <h2 className='text-xl font-semibold text-white-100'>Gelen Dekontlar</h2>
          <div className="text-white-100 text-lg font-semibold">
            Bakiye: {balance_try ? `${balance_try.toFixed(2)} TL` : '0.00 TL'}
          </div>
        </div>
        <span onClick={() => navigate(0)} className='bg-secondary text-white-100 px-2 py-1 rounded-md cursor-pointer'>Yenile</span>
      </div>
      <Orders data={data} />
      <Pagination currentPage={page} totalPages={pages} onPageChange={handlePageChange} />
    </div>
  )
}

export default OrdersContainer
